import React, { useEffect, useState } from 'react';
import { Col, Row } from '@gjensidige/core-grid';

import { useAppDispatch, useAppSelector } from '../hooks/appHooks';
import { checkLoginStatus } from '../lib/api';
import { updateLoadingStatus } from '../store/slices/offerSlice';
import tracker from '../tracking';
import { ErrorPageHandler } from '../components/Common/ErrorPage/ErrorPageHandler';
import { PageLoader } from '../components/Common/Loader/PageLoader';
import { WelcomeBackContainer } from '../containers/WelcomeBackContainer';
import { RoutingHelper } from '../utils/RoutingHelper';
import { TrackingHelper } from '../utils/TrackingHelper';

interface WelcomeBackPageProps {
  product: string;
  redirectPage: string;
  appModuleToTrack: string;
}
export const WelcomeBackPage: React.FC<WelcomeBackPageProps> = (
  props: WelcomeBackPageProps
) => {
  const isMetaDataReceived = useAppSelector(
    (state) => state.insurance.isMetaDataReceived
  );
  const dispatch = useAppDispatch();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    if (isMetaDataReceived) {
      const checkLoggedInStatus = async () => {
        const isUserLoggedIn = await checkLoginStatus();
        setIsLoggedIn(isUserLoggedIn);
      };
      checkLoggedInStatus();
      dispatch(updateLoadingStatus('succeeded'));
      trackWelcomePage(RoutingHelper.getProductFromUrl());
    }
  }, [isMetaDataReceived]);
  const trackWelcomePage = (productName: string) => {
    const summaryPayLoad = {
      event_name: 'checkout',
      application_name: 'webshop',
      application_module: props.appModuleToTrack,
      application_version: '2.0',
      business_area: 'insurance',
      customer_segment: 'private',
      page_pathname: `/apps/${
        tracker.options.application_name
      }/${props.appModuleToTrack}/${TrackingHelper.getScenarioNameFromProduct(
        productName
      )}/identification`,
      page_title: 'webshop-frontend-se',
      product_sku: [TrackingHelper.getProductNumberToTrack(productName)],
      product_variant_name: '',
      product_variant_quantity: '',
      product_variant_total: '',
      product_name: TrackingHelper.getProductListToTrack(productName),
      product_brand: ['insurance'],
      product_category: [TrackingHelper.getProductCategoryToTrack(productName)],
      product_unit_price: '',
      product_quantity: ['1'],
      scenario_name: TrackingHelper.getScenarioNameFromProduct(productName),
      scenario_step: 'identification',
      scenario_type: 'follow-up-offer'
    };
    tracker.trackView(summaryPayLoad);
  };
  return (
    <main>
      <PageLoader>
        <ErrorPageHandler>
          <div className="welcome-back-page">
            <Row className="mt-7">
              <Col className="welcome-back-contanier pb-3">
                <WelcomeBackContainer
                  product={props.product}
                  isLoggedIn={isLoggedIn}
                  redirectPage={props.redirectPage}
                />
              </Col>
            </Row>
          </div>
        </ErrorPageHandler>
      </PageLoader>
    </main>
  );
};
